import Config from "../../../../../shared/src/ranj/app/config/Config";

export default class GameConfig extends Config {

    constructor() {
        super();
    }


}